/**
 * 公用接口
 * {
 *   name: 调用接口的别名
 *   url：api
 *   method：get | post | put | delete
 * }
 */
export default {
  // 获取工作日
  checkWorkDay: {
    name: "checkWorkDay",
    url: "/ams/billquery/checkWorkDay",
    method: "get"
  }
};
